/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import {
    Box,
    TableCell,
    TableHead,
    TableRow,
    Checkbox,
    Menu,
    MenuItem,
    IconButton,
} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert'
import SortingIcon from "components/SortingIcon";
import styles from "./styles.module.scss"
import clsx from "clsx";

const TableHeader = (props) => {
    const {
        checked,
        journeyTestCases,
        setSortConfig,
        setCheckedTestCases,
        setPage,
        sortConfig
    } = props

    const [anchorEl, setAnchorEl] = useState(null)
    const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] = useState(false)
    const openAnchorEl = Boolean(anchorEl)

    const handleCheckAllCurrentPage = () => {
        const currentPageTestCasesIds = journeyTestCases.map(item => item.id)
        setCheckedTestCases(prev => [
            ...new Set([...prev, ...currentPageTestCasesIds])
        ])
        setIsHeaderCheckboxChecked(true)
        handleCloseCheckAllDropdown()
    }

    const handleUncheckAllCurrentPage = () => {
        const currentPageTestCasesIds = journeyTestCases.map(item => item.id)
        setCheckedTestCases(prev =>
            prev.filter(id => !currentPageTestCasesIds.includes(id))
        )
        setIsHeaderCheckboxChecked(false)
        handleCloseCheckAllDropdown()
    }

    const handleClickCheckAllDropdown = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleCloseCheckAllDropdown = () => {
        setAnchorEl(null)
    }

    const handleSortChange = (key) => {
        setPage(1);
        setSortConfig((prevConfig) => ({
            key,
            direction:
                prevConfig.key === key && prevConfig.direction === "asc"
                    ? "desc"
                    : "asc",
        }));
    };

    useEffect(() => {
        if (checked.length === 0 || checked.length < journeyTestCases.length) {
            setIsHeaderCheckboxChecked(false);
        }
    }, [checked, journeyTestCases.length])

    return (
        <TableHead className={styles.tableHeader}>
            <TableRow>
                <TableCell className={styles.checkboxCell} padding="checkbox">
                    <Box className={styles.checkboxCellContent}>
                        <Checkbox
                            size="small"
                            sx={{ padding: 0 }}
                            checked={isHeaderCheckboxChecked}
                            onChange={(e) => {
                                const allChecked = e.target.checked
                                if (!allChecked) {

                                    return handleUncheckAllCurrentPage()
                                }
                                handleCheckAllCurrentPage()
                            }}
                        />
                        <IconButton
                            onClick={handleClickCheckAllDropdown}
                            size="small"
                            sx={{ p: 0 }}
                        >
                            <MoreVertIcon fontSize="small" />
                        </IconButton>
                    </Box>
                    <Menu
                        anchorEl={anchorEl}
                        open={openAnchorEl}
                        onClose={handleCloseCheckAllDropdown}
                    >
                        <MenuItem onClick={handleCheckAllCurrentPage} sx={{ minWidth: '100px' }}>All</MenuItem>
                        <MenuItem onClick={handleUncheckAllCurrentPage}>None</MenuItem>
                    </Menu>
                </TableCell>
                <TableCell
                    className={clsx(styles.headerCell, styles.testCaseId)}
                    onClick={() => handleSortChange("public_id")}
                >
                    <Box className={styles.headerCellContent}>
                        <SortingIcon
                            sortConfig={sortConfig}
                            currentKey={"public_id"}
                        />
                        Test Case ID
                    </Box>
                </TableCell>
                <TableCell
                    className={clsx(styles.headerCell, styles.testCaseName)}
                    onClick={() => handleSortChange("name")}
                >
                    <Box className={styles.headerCellContent}>
                        <SortingIcon
                            sortConfig={sortConfig}
                            currentKey={"name"}
                        />
                        Test Case Name
                    </Box>
                </TableCell>
                <TableCell
                    className={styles.headerCell}
                    onClick={() =>
                        handleSortChange("created_at")
                    }
                >
                    <Box className={styles.headerCellContent}>
                        <SortingIcon
                            sortConfig={sortConfig}
                            currentKey={"created_at"}
                        />
                        Created
                    </Box>
                </TableCell>
                <TableCell
                    className={styles.headerCell}
                    onClick={() =>
                        handleSortChange("regenerated_at")
                    }
                >
                    <Box className={styles.headerCellContent}>
                        <SortingIcon
                            sortConfig={sortConfig}
                            currentKey={"regenerated_at"}
                        />
                        Last Updated
                    </Box>
                </TableCell>
                <TableCell
                    className={styles.headerCell}
                    onClick={() =>
                        handleSortChange("status")
                    }
                >
                    <Box className={styles.headerCellContent}>
                        <SortingIcon
                            sortConfig={sortConfig}
                            currentKey={"status"}
                        />
                        Status
                    </Box>
                </TableCell>
                <TableCell className={clsx(styles.headerCellContent, styles.testCasesActions)}>
                    Actions
                </TableCell>
            </TableRow>
        </TableHead>
    );
}

export default TableHeader;
